<template>
  <div class="content">
    <!-- <div class="xz" v-for="index in 12" :key="index" @click="clickXz(index)">
      <img class="xz-img" src="../../../assets/xz/1.png" alt="" />
      <div class="xz-name">金牛座</div>
      <div class="xz-en">Taurus</div>
      <div class="xz-date">•3.29 — 3.29•</div>
    </div> -->
    <div class="xz" v-for="(item,index) in list" :key="index" @click="clickXz(item.id)">
      <img class="xz-img" :src="item.icon" alt="" />
      <div class="xz-name">{{item.title}}</div>
      <div class="xz-en">Taurus</div>
      <div class="xz-date">•{{item.time}}•</div>
    </div>
    <shareBottomComp v-if="share == 1"></shareBottomComp>
  </div>
</template>

<script>
/**
@description:星座
@createTime:2021-08-24
@create:wq
*/
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
import shareBottomComp from "@/components/shareBottomComp";
export default {
  name: "",
  props: {},
  components: {shareBottomComp},
  data() {
    return {
      list: [{}],
      share:0
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getDataList();
    if (getQueryString("share")) {
      this.share = 1;
    } else {
      this.share = 0;
    }
  },
  methods: {
    clickXz(id) {
      this.$router.push({ path: "/xzdetails",query: {id: id} });
    },
    getDataList(){
      this.api.fortuneList({type:1}).then((res) => {
        this.list = res.data;
        shareJsSdk('xz','星座运势详解');
      });
    }
  },
  // 在创建之前，添加body的style属性， 单独设置背景色
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#000000");
  },
  // 在销毁前，将body的style属性删除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0.2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  > div {
    // width: calc(100vw / 3);
    width: 2.26rem;
    height: 3.52rem;
    margin-bottom: 0.1rem;
    background-image: url(../../../assets/xz/xz.png);
    background-size: 100% 100%;
    // img {
    //   width: 100%;
    // }
  }
}
.xz {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.xz-img {
  width: 1.06rem;
  height: 1.06rem;
}
.xz-name {
  font-size: 0.28rem;
  font-weight: bold;
  color: #ffffff;
  margin-top: 0.2rem;
}
.xz-en {
  font-size: 0.2rem;
  font-family: Source Han Serif CN;
  font-weight: 800;
  color: #e8c9a2;
}
.xz-date {
  font-size: 0.18rem;
  font-family: Source Han Serif CN;
  font-weight: 800;
  color: #666666;
  margin-top: 0.16rem;
}
</style>
